import React, { Component } from "react";
import CustomBoardRenewal from "../../../../components/CustomBoardRenewal";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import Grid from "@material-ui/core/Grid";
import CustomButton from "../../../../components/CustomButton";
import ReactHtmlParser from "react-html-parser";
import * as selector from "../../../../../common/selectors";
import * as onlineRenewalSelector from "../../../../../common/selectors/onlineRenewal";
import ReactGA from "react-ga";

class RenewalUnsuccessful extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      redirecting: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onClickRetryRenewal = () => {
    ReactGA.event({
      category: "RenewalPages",
      action: "Retry Renewal",
    });
    const { history } = this.props;
    history.push("/OnlineRenewal");
  };

  onClickRepurchase = () => {
    ReactGA.event({
      category: "RenewalPages",
      action: "Repurchase",
    });
    const { checkRenewabilityData } = this.props;
    const tiqHome = onlineRenewalSelector.checkRenewabilityDataTiqHome(
      checkRenewabilityData
    );
    const tiqHomeUrl = onlineRenewalSelector.checkRenewabilityDataTiqHomeUrl(
      checkRenewabilityData
    );
    const isTiqHome = onlineRenewalSelector.checkRenewabilityDataIsTiqHome(
      checkRenewabilityData
    );

    const redirectUrl = onlineRenewalSelector.checkRenewabilityDataRedirectUrl(
      checkRenewabilityData
    );

    if (redirectUrl !== null) {
      window.location.href = redirectUrl;
    }else{
      window.location.href ="https://etiqa.com.sg/online/quotation/home-renewal";
    }

    // if(isTiqHome === true){
    //   if(tiqHome !== null  && tiqHomeUrl !== null){

    //     let form = document.createElement("form");
    //     form.setAttribute("method", "post");
    //     form.setAttribute(
    //       "action",
    //       tiqHomeUrl
    //     );
    //     let field = [
    //       { name: "PDPADMail", value: tiqHome.PDPADMail },
    //       { name: "PDPAEmail", value: tiqHome.PDPAEmail },
    //       { name: "APIName", value: tiqHome.APIName },
    //       { name: "PDPAPhone", value: tiqHome.PDPAPhone },
    //       { name: "PDPASMS", value: tiqHome.PDPASMS },
    //       {
    //         name: "RenewalStartDate",
    //         value:
    //         tiqHome.RenewalStartDate,
    //         // returnUrl,
    //       },
    //       { name: "dob", value: tiqHome.dob },
    //       { name: "email", value: tiqHome.email },
    //       { name: "hdbRoomType", value: tiqHome.hdbRoomType },
    //       { name: "mailing_block", value: tiqHome.mailing_block },
    //       { name: "mailing_building", value: tiqHome.mailing_building },
    //       { name: "mailing_postal", value: tiqHome.mailing_postal },
    //       { name: "mailing_street", value: tiqHome.mailing_street },
    //       { name: "mailing_unit", value: tiqHome.mailing_unit },
    //       { name: "mobile", value: tiqHome.mobile },
    //       { name: "name", value: tiqHome.name },
    //       { name: "nric", value: tiqHome.nric },
    //       { name: "property_block", value: tiqHome.property_block },
    //       { name: "property_building", value: tiqHome.property_building },
    //       { name: "property_postal", value: tiqHome.property_postal },
    //       { name: "property_street", value: tiqHome.property_street },
    //       { name: "property_unit", value: tiqHome.property_unit },

    //     ];
    //     for (let i = 0; i < field.length; i++) {
    //       let hf = document.createElement("input");
    //       hf.setAttribute("type", "hidden");
    //       hf.setAttribute("name", field[i].name);
    //       hf.setAttribute("value", field[i].value);
    //       form.appendChild(hf);
    //     }
    //     document.body.appendChild(form);
    //     form.submit();
    //   }

    // }else{
    //   window.location.href ="https://etiqa.com.sg/online/quotation/home-renewal";
    //   this.setState({redirecting:true})
    // }
  };

  renderChildren = () => {
    const { classes, checkRenewabilityData } = this.props;

    const msg = onlineRenewalSelector.checkRenewabilityDataMessage(
      checkRenewabilityData
    );
    const failedStatus = onlineRenewalSelector.checkRenewabilityDataRenewabilityStatus(
      checkRenewabilityData
    );
    const statusLabel = onlineRenewalSelector.checkRenewabilityDataStatusLabel(
      checkRenewabilityData
    );

    return (
      <Grid container direction={"column"} spacing={2}>
        <Grid item>
          <CustomText
            design={classes.renewNowTextStyle}
            style={{ color: "#2c3034" }}
          >
            {statusLabel}
          </CustomText>
        </Grid>

        {failedStatus === 13 ? (
          <Grid item>
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                {/* <CustomText design={classes.textStyle}>
                 Payment Processing
                </CustomText> */}
                <CustomText design={classes.textStyle}>
                 Your payment is being processed.
                </CustomText>
                <CustomText design={classes.textStyle}>
                You'll receive a confirmation email once it's successful.
                </CustomText>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          false
        )}

        {failedStatus === 2 ? (
          <Grid item>
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <CustomText design={classes.textStyle}>
                  We are unable to process your request.
                </CustomText>
                <CustomText design={classes.textStyle}>
                  Please Whatsapp our friendly Customer Care Consultants at +65{" "}
                  <b>
                    <u>6</u>
                  </b>
                  887 8777 during our operating hours - Mondays to Fridays,
                  8.45am to 5.30pm or you may contact your servicing agent.
                </CustomText>
                <CustomText design={classes.textStyle}>
                  We apologise for any inconvenience caused.
                </CustomText>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          false
        )}

        {failedStatus === 3 ? (
          <Grid item>
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <CustomText design={classes.textStyle}>
                  Sorry, we are unable to renew your insurance policy as it has
                  either expired or is not due for renewal.
                </CustomText>
                <CustomText design={classes.textStyle}>
                  Please Whatsapp our Customer Care team at +65{" "}
                  <b>
                    <u>6</u>
                  </b>
                  887 8777 during our operating hours – Monday to Friday, 8.45am
                  to 5.30pm or you may contact your servicing agent.
                </CustomText>
                <CustomText design={classes.textStyle}>
                  We apologise for any inconvenience caused.
                </CustomText>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          false
        )}

        {failedStatus === 4 ? (
          <Grid item>
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <CustomText design={classes.textStyle}>
                  Your policy needs to be repurchased.
                </CustomText>
                <CustomText design={classes.textStyle}>
                  Please click below for the next steps.
                </CustomText>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          false
        )}

        {failedStatus === 5 ? (
          <Grid item>
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <CustomText design={classes.textStyle}>
                  Sorry, we are unable to process your renewal.
                </CustomText>
                <CustomText design={classes.textStyle}>
                  Please Whatsapp our Customer Care Consultants at +65 6887
                  8777.(Mondays to Fridays, 8.45am to 5.30pm. We are closed on
                  Saturdays, Sundays and Public Holidays.)
                </CustomText>
                <CustomText design={classes.textStyle}>Thank you.</CustomText>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          false
        )}

        {failedStatus === 6 ? (
          <Grid item>
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <CustomText design={classes.textStyle}>
                  We are unable to process your request.
                </CustomText>
                <CustomText design={classes.textStyle}>
                  Please try again later or Whatsapp our Customer Care
                  Consultants at +65 6887 8777.(Mondays to Fridays, 8.45am to
                  5.30pm. We are closed on Saturdays, Sundays and Public
                  Holidays.).
                </CustomText>
                <CustomText design={classes.textStyle}>Thank you.</CustomText>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          false
        )}

        {failedStatus === 9 ? (
          <Grid item>
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <CustomText design={classes.textStyle}>
                  Your policy has expired.
                </CustomText>
                <CustomText design={classes.textStyle}>
                  Proceed to start your coverage now.
                </CustomText>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          false
        )}

        {failedStatus === 12 ? (
          <Grid item>
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <CustomText design={classes.textStyle}>
                  We are unable to process your request.
                </CustomText>
                <CustomText design={classes.textStyle}>
                  Please try again later or Whatsapp our Customer Care
                  Consultants at +65 6887 8777.(Mondays to Fridays, 8.45am to
                  5.30pm. We are closed on Saturdays, Sundays and Public
                  Holidays.).
                </CustomText>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          false
        )}

        {failedStatus === 3 ? (
          <Grid item>
            <CustomButton
              title={"Back"}
              design={classes.retryRenewalButton}
              textstyle={classes.buttonTextStyle}
              onClick={this.onClickRetryRenewal}
            />
          </Grid>
        ) : (
          false
        )}
        {failedStatus === (2 || 5 || 6 || 12) ? (
          <Grid item>
            <CustomButton
              title={"Retry Renewal"}
              design={classes.retryRenewalButton}
              textstyle={classes.buttonTextStyle}
              onClick={this.onClickRetryRenewal}
            />
          </Grid>
        ) : (
          false
        )}
        {failedStatus === 4 ? (
          <Grid item>
            <CustomButton
              title={"Repurchase"}
              design={classes.retryRenewalButton}
              textstyle={classes.buttonTextStyle}
              onClick={this.onClickRepurchase}
            />
          </Grid>
        ) : (
          false
        )}
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoardRenewal
          children={this.renderChildren()}
          height={height}
          width={width}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  checkButtonStyle: {
    height: 40,
    fullWidth: true,
    marginTop: 10,
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  renewNowTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
    marginBottom: 10,
  },
  retryRenewalButton: {
    width: 160,
    marginTop: 10,
  },
  textStyle: {
    marginBottom: 20,
  },
});

function mapStateToProps(state) {
  return {
    checkRenewabilityData: selector.checkRenewabilityData(state),
    checkRenewabilityLoading: selector.checkRenewabilityLoading(state),
    checkRenewabilityStatus: selector.checkRenewabilityStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(RenewalUnsuccessful)));
